import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { AccessReportsAdmin } from "@app/access-reports/admin";
import { AccessReportOverview, WrappedAccessReportsDashboard } from "@app/access-reports/dashboard";
import { AccessReportsWizard } from "@app/access-reports/wizard";
import { RouteRestrictionBoundary } from "@app/authorization";
import { NotFound, Unauthorized } from "@app/shared/ErrorPages";
import { Roles, UserContext, UserInfo } from "@app/user";
import { JSX } from "react";

/** Renders the routing components for the access reports sub-section of the app. */
export default function AccessReportsRouter(props: RouteComponentProps<unknown>): JSX.Element {
  return (
    <UserContext.Consumer>
      {(user: UserInfo) => (
        (user && (
          user.roles.includes(Roles.ACCESS_REPORTS_VIEWER) ||
          user.roles.includes(Roles.ACCESS_REPORTS_ADMIN) ||
          user.roles.includes(Roles.ACCESS_REPORTS_WIZARD_ADMIN)))
          ? (
            <RouteRestrictionBoundary user={user} {...props}>
              <Switch>
                <Route path={`${props.match.path}`} exact={true} component={WrappedAccessReportsDashboard} />
                <Route
                  path={`${props.match.path}/wizard`}
                  render={(props) =>
                    <AccessReportsWizard
                      {...props}
                      clientId={user.clientId}
                      email={user.email}
                    />
                  }
                />
                <Route path={`${props.match.path}/overview/:accessReportId`} component={AccessReportOverview} />

                {user.roles.includes(Roles.ACCESS_REPORTS_WIZARD_ADMIN) ? (
                  <Route
                    path={`${props.match.path}/admin`}
                    render={(props) =>
                      <AccessReportsAdmin
                        {...props}
                        user={user}
                      />
                    }
                  />
                ) : (
                  <Unauthorized />
                )}
                <Route component={NotFound} />
              </Switch>
            </RouteRestrictionBoundary>
          ) : (
            <Unauthorized />
          )
      )}
    </UserContext.Consumer>
  );
}
